import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("section", { class: "section" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "notification is-light" }, " Update December 10, 2021: added new ghost The Mimic ")
], -1)
const _hoisted_2 = { class: "columns" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = { class: "section" }
const _hoisted_5 = { class: "column" }
const _hoisted_6 = { class: "section" }
const _hoisted_7 = { class: "section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EvidenceSelector = _resolveComponent("EvidenceSelector")!
  const _component_EvidenceProbability = _resolveComponent("EvidenceProbability")!
  const _component_GhostPossibilities = _resolveComponent("GhostPossibilities")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("section", _hoisted_4, [
          _createVNode(_component_EvidenceSelector, {
            onEvidenceChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.evidence = $event)),
            amount: 3,
            evidenceOptions: _ctx.evidenceTypes
          }, null, 8, ["evidenceOptions"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("section", _hoisted_6, [
          _createVNode(_component_EvidenceProbability, {
            evidence: _ctx.evidence,
            ghosts: _ctx.possibleGhosts
          }, null, 8, ["evidence", "ghosts"])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_7, [
      _createVNode(_component_GhostPossibilities, {
        evidence: _ctx.evidence,
        ghosts: _ctx.possibleGhosts
      }, null, 8, ["evidence", "ghosts"])
    ])
  ], 64))
}